import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  Alert
} from '@mui/material';
import { CustomInput } from '../../../../components/CustomInput';
import { LANGUAGES } from '../../constants';
import { createPromotionButton } from '../../../../api/companyPromotions';

export const CreateButtonModal = ({ open, onClose, onButtonCreated }) => {
  const [newButton, setNewButton] = useState({
    button_name: '',
    text_ru: '',
    text_kk: '',
    text_en: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field, value) => {
    setNewButton(prev => ({
      ...prev,
      [field]: value
    }));
    if (error) setError('');
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await createPromotionButton(newButton);
      if (response.data) {
        // Вызываем callback для обновления списка кнопок
        onButtonCreated(response.data);
        
        // Сбрасываем форму
        setNewButton({
          button_name: '',
          text_ru: '',
          text_kk: '',
          text_en: ''
        });
        
        onClose();
      }
    } catch (error) {
      console.error('Ошибка при создании кнопки:', error);
      setError('Ошибка при создании кнопки. Попробуйте еще раз.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewButton({
      button_name: '',
      text_ru: '',
      text_kk: '',
      text_en: ''
    });
    setError('');
    onClose();
  };

  const isFormValid = newButton.button_name && 
                     newButton.text_ru && 
                     newButton.text_kk && 
                     newButton.text_en;

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Создание новой кнопки
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                placeholder="Название кнопки (button_name)"
                value={newButton.button_name}
                onChange={(e) => handleInputChange('button_name', e.target.value)}
                fullWidth
                required
              />
            </Grid>
            
            {LANGUAGES.map(lang => (
              <Grid item xs={12} md={4} key={lang.value}>
                <CustomInput
                  placeholder={`Текст кнопки (${lang.label})`}
                  value={newButton[`text_${lang.value}`]}
                  onChange={(e) => handleInputChange(`text_${lang.value}`, e.target.value)}
                  fullWidth
                  required
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 3 }}>
        <Button 
          onClick={handleClose}
          disabled={loading}
        >
          Отмена
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!isFormValid || loading}
        >
          {loading ? 'Создание...' : 'Создать кнопку'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CreateButtonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onButtonCreated: PropTypes.func.isRequired
};
